import { ReadableStream } from 'web-streams-polyfill';

import type { StreamSource } from '@iconik-io/uploader/src/state';
import type { GetSourceStreamOptions } from '@iconik-io/uploader/src/types';

import { getRegisteredFile } from './file_registry';

export const getSourceStream = (
  streamSource: StreamSource,
  options: GetSourceStreamOptions,
): ReadableStream => {
  if (streamSource.type !== 'fileRef') {
    throw new Error(`Unsupported stream source type: ${streamSource.type}`);
  }
  const file = getRegisteredFile(streamSource.id);
  if (!file) {
    throw new Error(`No file is registered for ${streamSource.id}`);
  }

  let offset = 0;
  const chunkSize = options.chunkSize;

  return new ReadableStream({
    type: 'bytes',
    async pull(controller) {
      const chunk = file.slice(offset, offset + chunkSize);
      const reader = new FileReader();

      reader.onload = () => {
        if (!reader.result) {
          throw new Error('Expected result to be defined');
        }
        if (typeof reader.result === 'string') {
          throw new Error('Expected result to be an ArrayBuffer');
        }
        controller.enqueue(new Uint8Array(reader.result));
        offset += chunkSize;

        // Close stream when file end is reached
        if (offset >= file.size) {
          controller.close();
        }
      };

      reader.onerror = (error) => controller.error(error);

      reader.readAsArrayBuffer(chunk);
    },
  });
};
